<template>
  <IziPage>
    <template #header>
      <h3>{{ t("register") }}</h3>
    </template>
    <template #default>
      <IziGrid>
        <IziCol>
          <form novalidate @submit.prevent="onSubmit">
            <IziGrid>
              <IziCol class="display-name">
                <IziGrid margin="0px" padding="0px">
                  <div class="p-col-12 p-xl-6 p-lg-6 p-md-6">
                    <IziInput
                      v-model:value="formGroup.firstName.value"
                      :type="'text'"
                      :label="t('register-firstname')"
                      :name="'firstName'"
                      :msg="msg.firstName"
                      icon="pi-search"
                      iconPos="left"
                      @blur="blur('firstName')"
                    />
                  </div>
                  <div class="p-col-12 p-xl-6 p-lg-6 p-md-6">
                    <IziInput
                      v-model:value="formGroup.lastName.value"
                      :type="'text'"
                      :label="t('register-lastname')"
                      :name="'lastName'"
                      :msg="msg.lastName"
                      @blur="blur('lastName')"
                    />
                  </div>
                </IziGrid>
              </IziCol>
              <IziCol>
                <IziInput
                  v-model:value="formGroup.userName.value"
                  :type="'text'"
                  :label="t('register-username')"
                  :name="'userName'"
                  :msg="msg.userName"
                  @blur="blur('userName')"
                />
              </IziCol>
              <IziCol>
                <IziInput
                  v-model:value="formGroup.email.value"
                  :type="'text'"
                  :label="t('register-email')"
                  :name="'email'"
                  :msg="msg.email"
                  @blur="blur('email')"
                />
              </IziCol>
              <IziCol>
                <IziInput
                  v-model:value="formGroup.password.value"
                  :type="'password'"
                  :label="t('register-password')"
                  :name="'password'"
                  :msg="msg.password"
                  @blur="blur('password')"
                />
              </IziCol>
              <IziCol>
                <IziInput
                  v-model:value="formGroup.confirmPassword.value"
                  :type="'password'"
                  :label="t('register-confirmPassword')"
                  :name="'confirmPassword'"
                  :msg="msg.confirmPassword"
                  @blur="blur('confirmPassword')"
                />
              </IziCol>
              <IziCol class="action-register-form">
                <IziButton
                  :label="t('register')"
                  type="submit"
                  size="lg"
                  class="button-register"
                  buttonType="primary"
                />
              </IziCol>
            </IziGrid>
          </form>
        </IziCol>
      </IziGrid>
    </template>
  </IziPage>
</template>
<script lang="ts">
import { Options } from "vue-class-component";
import { email, required, confirmPassword } from "../../services/validators";
import { FormGroup } from "../../model/FormGroup.model";
import { Message } from "../../model/Message.model";
import BaseForm from "../../components/baseForm/baseForm.vue";
import { computed } from "vue";

@Options({})
export default class RegisterForm extends BaseForm {
  public msg: Message = {
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    password: "",
    confirmPassword: ""
  };

  public formGroup: FormGroup = {
    firstName: { rules: [required()], value: "" },
    lastName: { rules: [required()], value: "" },
    userName: { rules: [required()], value: "" },
    email: { rules: [email()], value: "" },
    password: { rules: [required()], value: "" },
    confirmPassword: {
      rules: [
        required(),
        confirmPassword(computed(() => this.formGroup.password.value))
      ],
      value: ""
    }
  };
}
</script>

<style lang="scss">
.display-name {
  padding: 0px;
}

.action-register-form {
  text-align: center;
}

.button-register {
  width: 100%;
}
</style>
